// extracted by mini-css-extract-plugin
export default {"footer":"AdminFooter_footer__unfJ8","footerContent":"AdminFooter_footerContent__7B1wY","footerLeft":"AdminFooter_footerLeft__cQgJi","footerRight":"AdminFooter_footerRight__F13nu"};